module.exports = __webpack_public_path__ + "img/speed_city_vip@2x.b4ea9f2c.png";